import React from "react";
import { FaAngleRight } from "react-icons/fa6";
import { Imagekit } from "../../Pages/CommonPages/ImageKit";
import defaultProductImage from "../../assets/images/default-product.png";

const CategorieGroup = ({ Tittle, List = [] }) => {
  return (
    <>
      <div className="text-[10px] font-[500] tracking-[0.1em] uppercase text-[#707078] px-[16px] pt-[12px] pb-[6px]">
        {Tittle}
      </div>
      {List.map((item, i) => {
        const name = typeof item === "string" ? item : item.name;
        const region = typeof item === "string" ? null : item.region;
        const image = typeof item === "string" ? null : item.image;
        const onClick = typeof item === "string" ? undefined : item.onClick;
        return (
          <div
            key={i}
            onClick={onClick}
            className="flex items-center justify-between px-[16px] py-[12px] cursor-pointer"
          >
            <div className="flex items-center gap-[14px] min-w-0">
              <span className="w-[32px] h-[32px] rounded-[8px] overflow-hidden flex-none bg-[#F5F5F5]">
                <Imagekit
                  IMGName={image || defaultProductImage}
                  alt=""
                  className="w-full h-full object-cover object-[center_top] block"
                />
              </span>
              <span className="text-[15px] font-[400] text-[#1F212E]">
                {name}
                {region ? (
                  <span className="text-[11px] font-[400] text-[#707078]">
                    {" "}
                    · {region}
                  </span>
                ) : null}
              </span>
            </div>
            <FaAngleRight className="text-[#707078] w-[16px] h-[16px] flex-none" />
          </div>
        );
      })}
    </>
  );
};

export default CategorieGroup;
